import { gql } from "@apollo/client";

export const IMPERSONATE = gql`
  query impersonate($email: String!) {
    impersonate(email: $email) {
      token
    }
  }
`;
